import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none",
  viewBox: "0 0 21 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.566 9.167c.46 0 .833.373.833.833v1.667a.833.833 0 0 1-1.666 0V10c0-.46.373-.833.833-.833M15.11 9.255a.833.833 0 0 1 1.118.372l.833 1.667a.833.833 0 0 1-1.49.745l-.834-1.666a.833.833 0 0 1 .373-1.118M10.022 9.255a.833.833 0 0 1 .372 1.118l-.833 1.666a.833.833 0 0 1-1.49-.745l.832-1.667a.833.833 0 0 1 1.118-.372",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5.275 3.333c-.575 0-1.042.467-1.042 1.042V17.5a.833.833 0 0 1-1.666 0V4.375a2.708 2.708 0 0 1 2.708-2.708h8.633c1.026 0 1.963.58 2.422 1.497l.962 1.924a1.667 1.667 0 0 1-1.49 2.412h-4.8c-.49 0-.972-.133-1.393-.386l-1.192-.716a1.042 1.042 0 0 0-.536-.148H6.317a.833.833 0 0 1 0-1.667H7.88c.49 0 .972.134 1.393.386l1.193.716c.162.097.347.148.536.148h4.799l-.963-1.924a1.042 1.042 0 0 0-.931-.576z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }